import type { CategoryContent } from './row.js';

export const ITALIAN_HISTORY: CategoryContent = {
  bscba: [
    [
      'Which Italian city-state became the dominant Mediterranean maritime power, controlling Eastern trade routes from the 9th century onward?',
      [
        'Venice',
        'Genoa',
        'Florence',
        'Milan',
      ],
      0,
      'Venice built a vast naval empire and trading network that dominated Mediterranean commerce until Napoleonic conquest.',
    ],
    [
      'The Medici family\'s wealth and patronage of the Renaissance was centered in which Italian city?',
      [
        'Florence',
        'Venice',
        'Rome',
        'Naples',
      ],
      0,
      'The Medici ruled Florence as merchants and bankers, becoming patrons of art and producing popes and queens.',
    ],
    [
      'What is the term for the 19th-century Italian nationalist movement that unified the peninsula?',
      [
        'Risorgimento',
        'Restaurazione',
        'Renouveau',
        'Republica',
      ],
      0,
      'Risorgimento ("resurrection") unified Italy from fragmentation, ending centuries of foreign domination.',
    ],
    [
      'Which military general led volunteer forces to conquer Sicily and Naples in 1860–1861?',
      [
        'Giuseppe Garibaldi',
        'Victor Emmanuel II',
        'Camillo Cavour',
        'Luigi Settimbrini',
      ],
      0,
      'Garibaldi\'s Thousand conquered Sicily and Naples, directly enabling the kingdom\'s political unification.',
    ],
    [
      'Which Piedmontese statesman orchestrated the diplomatic and political unification of Italy?',
      [
        'Camillo Cavour',
        'Giuseppe Mazzini',
        'Giuseppe Garibaldi',
        'Victor Emmanuel II',
      ],
      0,
      'Cavour, Prime Minister of Piedmont, used alliance and diplomacy to position Piedmont as unification\'s center.',
    ],
    [
      'In what year was the Kingdom of Italy officially proclaimed?',
      [
        '1861',
        '1848',
        '1815',
        '1870',
      ],
      0,
      'The Kingdom of Italy was declared on 17 March 1861 under Victor Emmanuel II, though Rome remained separate until 1870.',
    ],
    [
      'Which dictator took power in Italy through the March on Rome in 1922?',
      [
        'Benito Mussolini',
        'Victor Emmanuel III',
        'Francesco Crispi',
        'Luigi Facta',
      ],
      0,
      'Mussolini\'s Blackshirts marched on Rome in 1922, forcing the king to appoint him Prime Minister.',
    ],
    [
      'What major event in 1870 completed Italian territorial unification?',
      [
        'Italian troops seized Rome',
        'Pope Pius IX voluntarily joined the kingdom',
        'International powers granted Rome to Italy',
        'The Vatican signed a peace treaty',
      ],
      0,
      'In 1870, Italian troops breached Rome\'s walls, ending papal territorial power and completing unification.',
    ],
    [
      'In what year was the Italian Republic established, replacing the monarchy?',
      [
        '1946',
        '1943',
        '1948',
        '1950',
      ],
      0,
      'A June 1946 referendum abolished the monarchy; Italy\'s new constitution took effect January 1948.',
    ],
    [
      'Which foreign power dominated much of Italy in the 16th and 17th centuries through kingdoms and city-state control?',
      [
        'Spain',
        'France',
        'Austria',
        'The Ottoman Empire',
      ],
      0,
      'Spain ruled southern Italy and held Milan after the Italian Wars, dominating the peninsula for two centuries.',
    ],
    [
      'After the Napoleonic Wars, which foreign power held Lombardy and Venetia?',
      [
        'Austria',
        'France',
        'Russia',
        'Prussia',
      ],
      0,
      'Austria controlled Lombardy and Venetia, forming the main obstacle to northern Italian unity.',
    ],
    [
      'Which revolutionary founded Young Italy, a secret society promoting unification?',
      [
        'Giuseppe Mazzini',
        'Camillo Cavour',
        'Victor Emmanuel II',
        'Niccolò Machiavelli',
      ],
      0,
      'Mazzini founded Young Italy (1831) to inspire nationalist action, though his republicanism lost to Cavour\'s monarchy.',
    ],
    [
      'Which northern Italian kingdom became the political and military center of unification?',
      [
        'Piedmont',
        'Lombardy',
        'Venetia',
        'Savoy',
      ],
      0,
      'Piedmont, under the House of Savoy, had Italy\'s strongest army and clearest unification vision.',
    ],
    [
      'Besides Venice, which Mediterranean city-state was a renowned medieval and Renaissance maritime power?',
      [
        'Genoa',
        'Amalfi',
        'Pisa',
        'Salerno',
      ],
      0,
      'Genoa rivaled Venice as a maritime republic, controlling Mediterranean and Black Sea trade routes.',
    ],
    [
      'Which treaty in 1929 resolved the "Roman Question" by establishing Vatican City\'s independence?',
      [
        'Lateran Treaty',
        'Treaty of Rome',
        'Conciliar Accord',
        'Papal Charter',
      ],
      0,
      'The Lateran Treaty created Vatican City as a sovereign state, ending papal territorial disputes.',
    ],
  ],
  msc: [
    [
      'Why did Cavour\'s monarchist approach ultimately prevail over Mazzini\'s republican vision?',
      [
        'Realpolitik beat idealism',
        'Republics were inherently unstable',
        'The papacy demanded a monarchy',
        'Mazzini controlled the military',
      ],
      0,
      'Cavour\'s pragmatic statecraft and Piedmont\'s power defeated Mazzini\'s federalist republicanism.',
    ],
    [
      'Under the Treaty of Turin (1860), what did Piedmont cede to France?',
      [
        'Nice and Savoy',
        'Piedmont itself',
        'Lombardy and Venetia',
        'Sicily and Naples',
      ],
      0,
      'Cavour traded Nice and Savoy to France, gaining critical support against Austria.',
    ],
    [
      'The conflict between Mazzini\'s vision and Cavour\'s strategy resulted in which outcome?',
      [
        'Constitutional monarchy, not a republic',
        'Italy became an ecclesiastical theocracy',
        'Italy split into independent republics',
        'Mazzini\'s model was universally adopted',
      ],
      0,
      'Cavour\'s realism secured unification as a monarchy under the House of Savoy.',
    ],
    [
      'The Italian Wars (1494–1559) primarily resulted from rivalry between which two powers?',
      [
        'Spain and France',
        'Venice and the Papacy',
        'Austria and Prussia',
        'Ottoman Empire and Venice',
      ],
      0,
      'Habsburgs (Spain) and Valois (France) fought for Italian control, leaving the peninsula fragmented.',
    ],
    [
      'Which dynasty ruled the Kingdom of the Two Sicilies (Naples and Sicily) after 1713?',
      [
        'The House of Bourbon',
        'The House of Valois',
        'The House of Habsburg',
        'The House of Orange',
      ],
      0,
      'Bourbon kings ruled Naples and Sicily as a prosperous kingdom separate from northern Italy.',
    ],
    [
      'Which Enlightenment jurist\'s treatise on crime and punishment reshaped European legal reform?',
      [
        'Cesare Beccaria',
        'Giovanni Vico',
        'Niccolò Machiavelli',
        'Antonio Genovesi',
      ],
      0,
      'Beccaria\'s 1764 work against torture and capital punishment influenced modern criminal justice.',
    ],
    [
      'The Congress of Vienna (1815) deliberately fragmented Italy under Austrian dominance. What was Metternich\'s aim?',
      [
        'To prevent unification',
        'To unify Italy immediately',
        'To establish an Italian republic',
        'To restore papal territorial power',
      ],
      0,
      'Metternich\'s Vienna settlement returned Italy to fragmentation to prevent nationalist challenges.',
    ],
    [
      'Who commanded Italian forces that captured Rome in 1870?',
      [
        'General Cadorna',
        'Giuseppe Garibaldi',
        'King Victor Emmanuel II',
        'Camillo Cavour',
      ],
      0,
      'General Cadorna\'s troops breached Rome\'s walls, ending papal temporal power.',
    ],
    [
      'Italy\'s 1866 alliance with Prussia in the Austro-Prussian War allowed it to acquire which territory?',
      [
        'Venetia',
        'Piedmont',
        'Tuscany',
        'Sicily',
      ],
      0,
      'Prussian victory enabled Italy to seize Venetia, the last major Italian territory held by Austria.',
    ],
    [
      'The Lateran Treaty (1929) established what regarding papal status?',
      [
        'Vatican City, independent under the Pope',
        'Full papal restoration of the Papal States',
        'Joint governance of Rome by Pope and Italy',
        'Complete Church-state separation',
      ],
      0,
      'The treaty created Vatican City, resolving the "Roman Question" of papal independence.',
    ],
    [
      'Mussolini\'s 1939 Pact of Steel with Nazi Germany committed Italy to what?',
      [
        'Unconditional support for Germany',
        'Merger of Italian and German governments',
        'Surrender of Italian colonies to Germany',
        'Immediate adoption of Nazi racial laws',
      ],
      0,
      'The Pact of Steel bound Italy militarily to Germany, leading to WWII involvement.',
    ],
    [
      'After Italy\'s 1943 armistice with the Allies, what puppet state did Germany establish in the north?',
      [
        'The Italian Social Republic',
        'The Provisional Italian Government',
        'The Northern Italian Kingdom',
        'The Fascist Democratic Republic',
      ],
      0,
      'Germany created the Italian Social Republic as a Nazi puppet state in occupied northern Italy.',
    ],
    [
      'What corruption scandal of the late 1980s and early 1990s destabilized the First Republic?',
      [
        'Tangentopoli',
        'Mafia Maxima',
        'Operazione Cristallo',
        'Scandalo Europeo',
      ],
      0,
      'Tangentopoli ("Bribery City") exposed systemic corruption, triggering investigations that destabilized the First Republic.',
    ],
    [
      'Why was Piedmont\'s alpine geographic position advantageous for unification?',
      [
        'It straddled the Alps',
        'It was the richest region in Italy',
        'It had the largest population',
        'It was protected from all invasion',
      ],
      0,
      'Savoy\'s dual-monarchy position enabled Cavour to negotiate with France while building Italian hegemony.',
    ],
    [
      'How did the dominance of Piedmontese and Tuscan dialects during unification affect Italian language?',
      [
        'Political power and literary prestige',
        'The Pope decreed only Piedmontese would be spoken',
        'All Italians naturally spoke the same dialect',
        'Southern Italians refused to learn other dialects',
      ],
      0,
      'Piedmont\'s power and Tuscany\'s literary prestige established their variants as modern Italian\'s basis.',
    ],
  ],
  phd: [
    [
      'How did the Peace of Westphalia (1648) institutionalize Italian fragmentation under Habsburg duopoly?',
      [
        'Partition between Austria and Spain',
        'It granted France complete dominion over Italy',
        'It restored the Roman Empire under papal authority',
        'It established the first united Italian kingdom',
      ],
      0,
      'Westphalia locked Italy into Habsburg control, fragmenting the peninsula until Napoleonic disruption.',
    ],
    [
      'What was the strategic doctrine underlying Metternich\'s deliberate Italian fragmentation post-1815?',
      [
        'A unified Italy would threaten Austrian hegemony',
        'Metternich believed unified Italy would become too democratic',
        'He wanted to strengthen papal political power',
        'He supported Italian independence and nationalism',
      ],
      0,
      'Metternich\'s concert rationalized fragmentation as necessary to contain both French and Italian nationalism.',
    ],
    [
      'Why did the failed 1848–49 liberal-nationalist uprisings reshape Italian political strategy?',
      [
        'Defeat discredited popular revolt',
        'The uprisings immediately succeeded',
        'There was no military defeat',
        'Italians rejected nationalism entirely',
      ],
      0,
      'The 1848–49 collapse discredited popular movements, opening the path to Cavour\'s elite-led realism.',
    ],
    [
      'How did Garibaldi\'s pragmatic acceptance of Victor Emmanuel II diverge from Mazzini\'s republicanism?',
      [
        'Garibaldi put unity above ideology',
        'Mazzini led monarchist plots',
        'Garibaldi wanted to restore the Papacy',
        'They had identical political visions',
      ],
      0,
      'Garibaldi\'s willingness to accept Savoy enabled Cavour\'s monarchist settlement, isolating Mazzini\'s republicanism.',
    ],
    [
      'What was the "Non expedit" decree, and how did it hinder Italian nation-building?',
      [
        'Pius IX barred Catholics from politics',
        'It required Catholics to support unification',
        'It mandated papal rule over all Italy',
        'It abolished Italian language and culture',
      ],
      0,
      'Non expedit isolated the papacy from Italian civic life for 60 years, fragmenting the nation\'s institutional unity.',
    ],
    [
      'What structural factors made southern Italy chronically underdeveloped after unification?',
      [
        'Feudal latifundia, resource extraction',
        'Southern Italians were inherently less capable',
        'The Mafia solely caused all poverty',
        'The North had no feudal history',
      ],
      0,
      'The Mezzogiorno\'s feudal agronomy, weak industry, and brigandage proved resistant to Piedmontese modernization.',
    ],
    [
      'The southern "brigandage war" (1861–1876) reflected which underlying social conflict?',
      [
        'Peasant unrest against conscription',
        'Spanish invaders started the revolts',
        'Foreign mercenaries alone caused brigandage',
        'It was purely a Mafia criminal enterprise',
      ],
      0,
      'Brigandage in the Mezzogiorno reflected genuine peasant grievances, quelled through harsh occupation without reform.',
    ],
    [
      'What characterized Giovanni Giolitti\'s governance (1903–1914) as a transitional phase between liberal Italy and fascism?',
      [
        'Suffrage expansion without structural reform',
        'Complete rejection of democracy',
        'Total alliance with the Papacy against secularism',
        'Restoration of absolute monarchy',
      ],
      0,
      'Giolitti\'s flexible liberalism broadened voting while preserving conservative élites, stalling transformative reform.',
    ],
    [
      'How did the notion of "vittoria mutilata" (mutilated victory) fuel resentment after World War I?',
      [
        'Fewer gains than promised',
        'Italy lost the entire war',
        'Italy gained more than promised',
        'Italy was never involved in WWI',
      ],
      0,
      'Postwar territorial disappointment and nationalist resentment created conditions for Mussolini\'s fascist rise.',
    ],
    [
      'What was the philosophical basis of Mussolini\'s corporatist economic model?',
      [
        'State syndicates replaced markets',
        'Establishment of free-market capitalism',
        'Wealth redistribution to workers alone',
        'Restoration of feudal agricultural systems',
      ],
      0,
      'Italian corporatism integrated all producers into fascist syndicates, eliminating independent markets and unions.',
    ],
    [
      'How did Italy\'s racial laws of 1938 differ initially from Nazi Germany\'s implementation?',
      [
        'Enforcement was initially laxer than Germany\'s',
        'Italian racial laws were as severe from the start',
        'Italy never enacted racial laws',
        'Italy immediately exceeded Nazi racial measures',
      ],
      0,
      'Italian fascism adopted racial laws for Nazi alignment, but social resistance softened enforcement until German occupation.',
    ],
    [
      'What paradoxical political status resulted from Italy\'s September 1943 armistice and subsequent war declaration?',
      [
        'Split into Allied south, German north',
        'Italy peacefully withdrew from WWII entirely',
        'Italy remained unified under Mussolini',
        'Germany immediately evacuated Italy',
      ],
      0,
      'Badoglio\'s armistice split Italy between Allied south and German-puppet north, creating the co-belligerent paradox.',
    ],
    [
      'How did the Italian Communist Party\'s (PCI) institutional status reshape postwar democracy?',
      [
        'The PCI stayed a legitimate opposition',
        'The PCI immediately seized total power',
        'It had no electoral support',
        'It rejected all democratic participation',
      ],
      0,
      'The PCI\'s democratic legitimacy prevented single-party dominance, institutionalizing leftist input in the First Republic.',
    ],
    [
      'What institutional feature of the First Republic did Tangentopoli\'s exposures fundamentally undermine?',
      [
        'It broke "partitocrazia"',
        'It had no institutional impact',
        'It strengthened the monarchy',
        'It reduced voting rights',
      ],
      0,
      'Tangentopoli dismantled postwar parties (DC, PSI) and triggered electoral reform, ending the First Republic\'s consensus model.',
    ],
    [
      'How did Petrarch\'s articulation of humanist virtue in the 14th century prefigure Florentine civic republicanism?',
      [
        'Classical virtue underpinned civic ideology',
        'Petrarch invented fascism',
        'Petrarch was a monarchist',
        'Classical learning had no role in Renaissance politics',
      ],
      0,
      'Petrarchan humanism\'s link between textual virtue and civic duty underpinned Florentine republican self-consciousness.',
    ],
  ],
  professor: [
    [
      'How did Florence\'s catasto reform of 1427 represent a technological and administrative innovation reshaping late-medieval state power?',
      [
        'A standardized census',
        'It abolished all taxation',
        'It restored pure feudalism',
        'It invented stock markets',
      ],
      0,
      'The catasto\'s rationalized, document-based assessment became foundational to early-modern state capacity and fiscal control.',
    ],
    [
      'How did the condottieri system both enable and constrain centralized Italian state development?',
      [
        'Freed cities, blocked unified command',
        'Condottieri had no political influence',
        'They immediately unified Italy',
        'They abolished all military activity',
      ],
      0,
      'Condottieri professionalized warfare but fragmented military loyalty, thwarting unified defense until the nation-state era.',
    ],
    [
      'How did the Treaty of Utrecht (1713) and subsequent Bourbon regalism alter the ecclesiastical-political balance in Naples?',
      [
        'Utrecht subordinated Church to the state',
        'The Papacy gained complete territorial control',
        'Ecclesiastical authority was abolished entirely',
        'The treaty had no political consequences',
      ],
      0,
      'Bourbon regalism subordinated Church appointments to state authority, diminishing papal influence and enabling Enlightenment reforms.',
    ],
    [
      'What ideological legacy did the failed Jacobin republics (1799–1815) leave despite their military collapse under Vienna?',
      [
        'Constitutional ideals resurged later',
        'Jacobinism had no lasting intellectual legacy',
        'The Jacobins immediately unified Italy',
        'Nationalism was invented after 1815',
      ],
      0,
      'Though militarily defeated, Jacobin republics implanted constitutional and nationalist ideals that resurged throughout the 19th century.',
    ],
    [
      'How did Cavour\'s realpolitik depart from the failed 1848–49 uprisings, and what was his core strategic insight?',
      [
        'Cavour chose diplomacy over revolt',
        'Cavour supported popular revolution exclusively',
        'He rejected all ties with foreign powers',
        'He relied only on diplomatic letters',
      ],
      0,
      'Cavour\'s pragmatic shift from grassroots to diplomatic statecraft enabled unification where ideology alone had failed.',
    ],
    [
      'What was the strategic significance of the secret Plombières agreement (1858) between Cavour and Napoleon III?',
      [
        'French support at the cost of Nice and Savoy',
        'Plombières prohibited any French alliance',
        'It guaranteed Italy would become a French colony',
        'It established immediate papal rule',
      ],
      0,
      'The Plombières bargain traded Savoyard territories for decisive intervention, institutionalizing unification\'s monarchist-secular trajectory.',
    ],
    [
      'How did the structural underdevelopment of the southern Mezzogiorno—rooted in latifundia feudalism—complicate postwar national integration?',
      [
        'Feudal latifundia, resource extraction',
        'The South was instantly prosperous',
        'Structural inequality came solely from the Mafia',
        'North and South were equally developed',
      ],
      0,
      'The Questione meridionale\'s feudal legacy and extraction perpetuated regional dualism into modern Italy.',
    ],
    [
      'Why did Giovanni Gentile\'s philosophical actualism, codified in the Riforma Gentile (1923), serve fascist totalitarian pedagogy?',
      [
        'It elevated the state above reason',
        'Gentile opposed fascism',
        'He advocated pure individualism',
        'His philosophy was unconnected to education',
      ],
      0,
      'Gentile\'s actualism provided philosophical legitimacy for fascist totalitarian pedagogy and youth indoctrination.',
    ],
    [
      'How did Italian internment camps in Libya, Greece, and the Balkans (1940–43) reveal fascist imperial methodology distinct from Nazi genocide?',
      [
        'Forced labor, starvation, not extermination',
        'Italy never established camps',
        'Italian deaths were from natural causes only',
        'Camps were purely for criminal rehabilitation',
      ],
      0,
      'Italian internment camps killed thousands through deliberate deprivation, revealing fascism\'s lethal racial ideology beyond Nazi typology.',
    ],
    [
      'What institutional mechanisms enabled the PCI\'s integration into First Republic consensus despite Cold War anticommunism?',
      [
        'Representation institutionalized the PCI',
        'The PCI was immediately excluded from politics',
        'The PCI and fascists united',
        'Italy had no postwar democratic institutions',
      ],
      0,
      'Proportional representation institutionalized communist participation, making the PCI a permanent opposition that constrained executive power.',
    ],
    [
      'How did Mussolini\'s intervention in World War I (1915) and subsequent defeat reshape fascism\'s emerging ideology?',
      [
        'Mutilated-victory resentment',
        'Italy won complete victory',
        'Italy suffered no casualties',
        'Postwar prosperity eliminated fascism',
      ],
      0,
      'Postwar resentment and 1919–22 biennio rosso crisis created the institutional vacuum fascism filled.',
    ],
    [
      'What did the Maastricht Treaty (1992) and euro transition (1999–2002) represent symbolically for Italian postwar sovereignty?',
      [
        'Voluntary transfer of monetary sovereignty',
        'Italy rejected the euro permanently',
        'Maastricht had no economic impact',
        'Italy voluntarily abandoned all sovereignty',
      ],
      0,
      'The euro transfer marked a profound renegotiation of nationalist monetary autonomy established during unification.',
    ],
    [
      'How did Mazzini\'s "guerra popolare" (people\'s war) ideology of mass peasant insurrection differ from Cavour\'s elite diplomatic realism?',
      [
        'Cavour\'s statecraft outmatched Mazzini\'s uprising',
        'Mazzini supported monarchy and Cavour supported republicanism',
        'They had identical visions',
        'Popular movements immediately succeeded',
      ],
      0,
      'Mazzini\'s ideology was outmaneuvered by Cavour\'s statecraft, institutionalizing monarchy over mass republicanism.',
    ],
    [
      'What did Silvio Berlusconi\'s multiple premierships (1994–2011) reveal about constitutional tensions in the Second Republic?',
      [
        'Conflicts of interest and corruption trials',
        'Berlusconi had no political influence',
        'He immediately restored fascism',
        'Constitutional law strengthened without controversy',
      ],
      0,
      'Berlusconi\'s media-political hybrid and anti-institutional rhetoric tested Italy\'s constitutional constraints.',
    ],
    [
      'How did the papal "temporal power" loss in 1870 and its resolution in the Lateran Treaty (1929) reshape church-state relations in unified Italy?',
      [
        'The 1870 rift, resolved in 1929',
        'The Papacy regained all territorial power',
        'Church and state were immediately separated',
        'The Lateran Treaty had no consequences',
      ],
      0,
      'The Lateran Treaty\'s Vatican City solution resolved 59 years of papal-state conflict and institutionalized ecclesiastical independence.',
    ],
  ],
};
